import { useState } from "react";
import { FastForward, Loader2, ListPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const ContinueBox = ({ ep, scenes, onContinue, onSplitNew, streaming, splitting, unsplitWords, dirty }) => {
  const [f, setF] = useState({ direction: "", minutes: 5, new_characters: "" });
  const runtime = Math.round((scenes.length * 20) / 60);
  return (
    <div className="panel p-5 space-y-3 border-cyan-500/30" data-testid="continue-box">
      <div className="flex items-center gap-2 text-cyan-400 font-mono text-xs tracking-widest"><FastForward className="w-3.5 h-3.5" /> CONTINUE THE STORY</div>
      <p className="text-[11px] text-slate-400">
        AI writes the next part after the end of your script, using the same cast. Existing scenes and approved clips stay as they are.
        {scenes.length > 0 && <> Currently {scenes.length} scenes (~{runtime} min).</>}
      </p>
      <Textarea data-testid="continue-direction-input" rows={3} placeholder="Where does the plot go next?" value={f.direction} onChange={(e) => setF({ ...f, direction: e.target.value })} />
      <Input data-testid="continue-new-characters-input" placeholder="New characters to introduce (optional)" value={f.new_characters} onChange={(e) => setF({ ...f, new_characters: e.target.value })} />
      <div className="flex items-center gap-3">
        <Input data-testid="continue-minutes-input" type="number" min={1} max={30} className="w-24" value={f.minutes}
          onChange={(e) => setF({ ...f, minutes: e.target.value === "" ? "" : Number(e.target.value) })} />
        <span className="text-xs text-slate-400">more minutes (~{(Number(f.minutes) || 0) * 3} scenes)</span>
      </div>
      <Button data-testid="continue-script-btn" variant="secondary" disabled={streaming || !f.direction.trim()} onClick={() => onContinue({ ...f, minutes: Number(f.minutes) || 5 })} className="w-full rounded-full">
        {streaming ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <FastForward className="w-4 h-4 mr-2" />}
        {streaming ? "Writing…" : "Write the next part"}
      </Button>
      {scenes.length > 0 && dirty && !unsplitWords && (
        <div className="text-[11px] text-amber-300" data-testid="save-to-add-hint">You have unsaved edits — Save the script to add any new text at the end as scenes.</div>
      )}
      {scenes.length > 0 && unsplitWords > 0 && (
        <div className="pt-2 border-t border-[#2A3245] space-y-2" data-testid="unsplit-part-notice">
          <div className="text-[11px] text-amber-300">{unsplitWords} new words not yet in scenes.</div>
          <Button data-testid="split-new-part-btn" disabled={streaming || splitting} onClick={onSplitNew} className="w-full rounded-full">
            {splitting ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <ListPlus className="w-4 h-4 mr-2" />}
            {splitting ? "Adding scenes…" : `Add as scenes ${scenes.length + 1}+`}
          </Button>
        </div>
      )}
    </div>
  );
};
